import React, { ReactElement } from "react";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import "../../../theme/style/loading.css";
import "../../../theme/style/wave.css";

import IconSelector from "../images/IconSelector";
import { ClusterIcon } from "../images/svgs/ClusterIcon";

const LoadingComponent = ({ section }: { section: string }): ReactElement => {
 const RenderIcon = () => {
  switch (section) {
   case "cluster":
    return <ClusterIcon className="loadingIcon" sx={{ color: "white" }} />;
   case "domains":
    return (
     <IconSelector
      icon="DomainIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   case "servers":
    return (
     <IconSelector
      icon="ServerIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   case "cloudboxes":
    return (
     <IconSelector
      icon="CloudboxIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   case "networks":
    return (
     <IconSelector
      icon="NetworkIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   case "firewalls":
    return (
     <IconSelector
      icon="FirewallIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   case "balancers":
    return (
     <IconSelector
      icon="BalancerIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   case "websites":
    return (
     <IconSelector
      icon="WebsiteIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   case "mails":
    return (
     <IconSelector
      icon="MailIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   case "zones":
    return (
     <IconSelector
      icon="ZoneIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   case "containersite":
    return (
     <IconSelector
      icon="DockerIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   case "containermail":
    return (
     <IconSelector
      icon="DockerIcon"
      props={{ className: "smallerLoadingIcon", sx: { color: "white" } }}
     />
    );
   default:
    return <></>;
  }
 };

 return (
  <Stack height="80vh" justifyContent="center" alignItems="center">
   <Paper
    elevation={1}
    sx={{ borderRadius: "100px", p: 2, width: 120, height: 120, backgroundColor: "#00278B" }}>
    <Stack justifyContent="center" alignItems="center" width="100%" height="100%" spacing={1}>
     <RenderIcon />
     {section === "cluster" && (
      <Stack
       sx={{
        width: 130,
        height: 80,
        borderRadius: 100,
        position: "absolute",
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "center"
       }}>
       <svg viewBox="0 0 500 150" preserveAspectRatio="none" height={20} width={"100%"}>
        <path
         className="w1 waveTop"
         d="M-8.74,71.55 C289.78,255.11 349.60,4.47 505.36,34.05 L500.00,150.00 L0.00,150.00 Z"
        />
        <path
         className="w2 waveMiddle"
         d="M-23.42,125.83 C187.63,45.89 299.38,57.73 526.80,123.86 L500.00,150.00 L0.00,150.00 Z"
        />
        <path
         className="w3 waveBottom"
         d="M-23.42,125.83 C172.96,-152.44 217.55,183.06 504.22,55.77 L500.00,150.00 L0.00,150.00 Z"
        />
       </svg>
      </Stack>
     )}
     <Typography variant="caption" color="white">
      Loading...
     </Typography>
    </Stack>
   </Paper>
  </Stack>
 );
};

export default LoadingComponent;
